<template>
  <BlFlexContainerMv
    class="prakerja-faq"
    direction="column">
    <BlTextAv variation="body-16" weight="bold" tag="h2" is-bolder class="mb-20">Pertanyaan Tentang Prakerja Bukalapak</BlTextAv>
    <div v-for="(faq, index) in sanitizeContents" :key="index">
      <BlAccordionMv class="bg-[#F8F9FA] mb-16 qa_prakerja_faq_tab">
        <template v-slot:header>
          <div v-html="faq.question" class="qa_prakerja_faq_tab_question"/>
        </template>
        <template v-slot:content>
          <div class="ph-12 pb-12 qa_prakerja_faq_tab_answer" slot="content" v-html="faq.answer" />
        </template>
      </BlAccordionMv>
    </div>
  </BlFlexContainerMv>
</template>

<script>
import { BlFlexContainerMv, BlAccordionMv, BlTextAv } from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaFAQ',
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },
  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlAccordionMv,
  },
  computed: {
    sanitizeContents() {
      var contents = [];
      for (const index in this.faqs) {
        const sanitizedFaq = {
          question: this.sanitizeContent(this.faqs[index].question),
          answer: this.sanitizeContent(this.faqs[index].answer),
        };
        contents.push(sanitizedFaq);
      }

      return contents;
    },
  },
  methods: {
    sanitizeContent(content) {
      return content
        .replace(/bl-text--body-16/g, 'bl-text--caption-12')
        .replace(/bl-text--subheading-18/g, 'bl-text--caption-12 bl-text--bold')
        .replace(/bl-text--subheading-20/g, 'bl-text--caption-14 bl-text--bold')
        .replace(/bl-text--heading-28/g, 'bl-text--body-16 bl-text--bold')
        .replace(/ml-16/g, '');
    },
  },
};
</script>
